export const colorSchemes = {
  application_status: {
    Declined: ["#ff0000", "#FFFFFF"],
    Approved: ["#99cc00", "#000000"],
    Withdraw: ["#ff0000", "#FFFFFF"],
  },
  deployment_status: {
    Sent: ["#ffe699", "#000000"],
    Pended: ["#ff0000", "#ffffff"],
    Approved: ["#5b9bd5", "#ffffff"],
    Ready: ["#ff99ff", "#000000"],
    Deployed: ["#c6e0b4", "#000000"],
    Live: ["#00b050", "#000000"],
    "Rejected Processor": ["#000000", "#FFFFFF"],
    "Rejected CNS": ["#000000", "#FFFFFF"],
    "Account Closed": ["#000000", "#FFFFFF"],
  },
  subscription_status: {
    Funded: ["#00b050", "#000000"],
    "Signup Bonus Due": ["#ffff00", "#000000"],
    "Deferred Subscription": ["#000000", "#FFFFFF"],
  },
};
